(function() {
  if (window.bbAddToCartAndOpenDrawer) return;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function runCartCtaShimmer(button) {
    if (!button || prefersReducedMotion() || button.dataset.bbCartShimmerDone === 'true') return;
    button.dataset.bbCartShimmerDone = 'true';
    button.classList.remove('is-cart-shimmering');
    button.offsetHeight;
    button.classList.add('is-cart-shimmering');
    window.setTimeout(function() {
      button.classList.remove('is-cart-shimmering');
    }, 1500);
  }

  function initializeCartCtaShimmer(root) {
    root = root || document;
    var buttons = root.querySelectorAll('[data-bb-sp-add], [data-bb-add]');
    buttons.forEach(function(button) {
      if (button.dataset.bbCartShimmerReady === 'true') return;
      button.dataset.bbCartShimmerReady = 'true';

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            window.setTimeout(function() {
              runCartCtaShimmer(button);
            }, 180);
          });
        }, { threshold: 0.55 });
        observer.observe(button);
      } else {
        window.setTimeout(function() {
          runCartCtaShimmer(button);
        }, 900);
      }
    });
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchWithTimeout(url, options) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = Number(window.BBCartRequestTimeoutMs);
    if (!Number.isFinite(timeout) || timeout < 1) timeout = 12000;
    var timer = null;
    var requestOptions = Object.assign({}, options || {});
    if (controller) {
      requestOptions.signal = controller.signal;
      timer = window.setTimeout(function() { controller.abort(); }, timeout);
    }
    return fetch(url, requestOptions).finally(function() {
      if (timer) window.clearTimeout(timer);
    });
  }

  window.bbCartFetch = fetchWithTimeout;

  function readJsonResponse(response) {
    return response.text().then(function(text) {
      var data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        data = { description: text || response.statusText };
      }
      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'Unable to update the cart.');
      }
      return data;
    });
  }

  function loadCart() {
    return fetchWithTimeout(routeRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to read the cart.');
      return response.json();
    });
  }

  function normalizedProperties(properties) {
    var result = {};
    Object.keys(properties || {}).sort().forEach(function(key) {
      var value = properties[key];
      if (value == null || String(value) === '') return;
      result[key] = String(value);
    });
    return result;
  }

  function sameProperties(actual, expected) {
    return JSON.stringify(normalizedProperties(actual)) === JSON.stringify(normalizedProperties(expected));
  }

  function payloadLines(payload) {
    if (payload instanceof FormData) {
      var properties = {};
      for (var entry of payload.entries()) {
        var match = String(entry[0]).match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = entry[1];
      }
      return [{
        variantId: String(payload.get('id') || ''),
        quantity: Number(payload.get('quantity')) || 0,
        properties: properties,
      }];
    }
    var values = payload && Array.isArray(payload.items) ? payload.items : [payload || {}];
    return values.map(function(item) {
      return {
        variantId: String(item.id || item.variant_id || ''),
        quantity: Number(item.quantity) || 0,
        properties: item.properties || {},
      };
    });
  }

  function matchingQuantity(cart, expected) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).reduce(function(total, item) {
      if (
        String(item.variant_id) === expected.variantId &&
        sameProperties(item.properties, expected.properties)
      ) {
        return total + Number(item.quantity || 0);
      }
      return total;
    }, 0);
  }

  function confirmsAddedLines(beforeCart, afterCart, expectedLines) {
    if (!beforeCart || !afterCart || !expectedLines.length) return false;
    return expectedLines.every(function(expected) {
      return matchingQuantity(afterCart, expected) >=
        matchingQuantity(beforeCart, expected) + expected.quantity;
    });
  }

  function notifyAddedWithoutDrawer() {
    if (window.BBToast && typeof window.BBToast.show === 'function') {
      window.BBToast.show({
        variant: 'warning',
        title: 'Added to cart',
        message: 'Your cart was updated, but the drawer could not refresh. Open the cart to review it.',
        dedupeKey: 'cart-added-drawer-refresh',
      });
    }
  }

  function setButtonState(button, label, text, isBusy) {
    if (!button) return;
    button.disabled = Boolean(isBusy);
    if (isBusy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
    if (label && text) label.textContent = text;
  }

  function syncDrawerFromHtml(html, trigger) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newItems = doc.querySelector('cart-drawer-items');
    var oldItems = document.querySelector('cart-drawer-items');
    if (newItems && oldItems) oldItems.replaceWith(newItems);

    var newFooter = doc.querySelector('.drawer__footer');
    var oldFooter = document.querySelector('#CartDrawer .drawer__footer');
    if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);

    var emptyState = document.querySelector('#CartDrawer .drawer__inner-empty');
    if (emptyState) emptyState.remove();

    var newHeading = doc.querySelector('.drawer__heading');
    var oldHeading = document.querySelector('#CartDrawer .drawer__heading');
    if (newHeading && oldHeading) oldHeading.innerHTML = newHeading.innerHTML;

    var newCount = doc.querySelector('.cart-count-badge');
    var count = newCount ? parseInt(newCount.textContent, 10) || 0 : 0;
    if (typeof window.bbSyncCartCount === 'function') window.bbSyncCartCount(count);

    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) throw new Error('Cart drawer is unavailable.');

    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') cartDrawer.open(trigger);
    else {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { source: 'drawer-refresh' }
    }));
  }

  function refreshAndOpenCartDrawer(trigger) {
    return fetchWithTimeout(routeRoot() + 'cart?section_id=cart-drawer')
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to refresh cart drawer.');
        return response.text();
      })
      .then(function(html) {
        syncDrawerFromHtml(html, trigger);
      });
  }

  window.bbRefreshAndOpenCartDrawer = refreshAndOpenCartDrawer;

  window.bbAddToCartAndOpenDrawer = function(options) {
    options = options || {};
    var button = options.button || null;
    var label = options.label || null;
    var defaultText = options.defaultText || (label ? label.textContent : '');
    var loadingText = options.loadingText || 'Adding...';
    var errorText = options.errorText || 'Could not add to cart';
    var payload = options.payload;
    var hadError = false;
    var beforeCart = null;
    var expectedLines = payloadLines(payload);

    if (!payload) return Promise.reject(new Error('Missing cart payload.'));

    var fetchOptions = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (payload instanceof FormData) {
      fetchOptions.body = payload;
    } else {
      fetchOptions.headers['Content-Type'] = 'application/json';
      fetchOptions.body = JSON.stringify(payload);
    }

    setButtonState(button, label, loadingText, true);

    return loadCart()
      .then(function(cart) {
        beforeCart = cart;
      })
      .catch(function() {})
      .then(function() {
        return fetchWithTimeout(routeRoot() + 'cart/add.js', fetchOptions);
      })
      .then(function(response) {
        return readJsonResponse(response);
      })
      .then(function(data) {
        return { added: true, data: data, reconciled: false };
      })
      .catch(function(error) {
        if (!beforeCart) throw error;
        return loadCart().then(function(cart) {
          if (!confirmsAddedLines(beforeCart, cart, expectedLines)) throw error;
          return { added: true, data: null, reconciled: true };
        });
      })
      .then(function(result) {
        return refreshAndOpenCartDrawer(button)
          .then(function() {
            result.drawerRefreshed = true;
            return result;
          })
          .catch(function() {
            return loadCart().then(function(cart) {
              if (!result.data && beforeCart && !confirmsAddedLines(beforeCart, cart, expectedLines)) {
                throw new Error('The cart update could not be confirmed.');
              }
              notifyAddedWithoutDrawer();
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'add-reconciled' }
              }));
              result.drawerRefreshed = false;
              result.reconciled = true;
              return result;
            });
          });
      })
      .catch(function(error) {
        hadError = true;
        console.error(error);
        if (label) label.textContent = errorText;
        if (typeof options.onError === 'function') options.onError(error);
        return { added: false, error: error };
      })
      .finally(function() {
        setButtonState(button, null, '', false);
        if (label && defaultText) {
          if (hadError) setTimeout(function() { label.textContent = defaultText; }, 2200);
          else label.textContent = defaultText;
        }
        if (typeof options.onFinally === 'function') options.onFinally();
      });
  };

  window.bbAddValidatedSelectionToCart = function(options) {
    options = options || {};
    var selection = options.selection || {};
    var payload = new FormData();
    payload.append('id', String(selection.variantId || ''));
    payload.append('quantity', String(Number(selection.quantity) || 0));

    var properties = Object.assign({}, selection.properties || {});
    if (selection.deliveryDate) properties['Delivery date'] = selection.deliveryDate;
    if (selection.offer) properties['_BadgeBuzz offer'] = selection.offer;
    if (selection.configuration) {
      properties['_BadgeBuzz configuration'] = selection.configuration;
    }
    Object.keys(properties).forEach(function(name) {
      if (properties[name] == null || String(properties[name]) === '') return;
      payload.append('properties[' + name + ']', String(properties[name]));
    });

    return window.bbAddToCartAndOpenDrawer(Object.assign({}, options, {
      payload: payload,
    }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeCartCtaShimmer(document);
    });
  } else {
    initializeCartCtaShimmer(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeCartCtaShimmer(event.target);
  });
})();
